export const checkinModalGlobal = {
  header: {
    phone: "Teléfono",
    accommodation: "Alojamiento",
    checkin: "Check-in",
    booking: "Reserva",
    notAvailable: "No disponible",
    notLinked: "No vinculado",
    defaultGuestName: "Invitado",
  },
  roles: {
    botStaff: "BOT / STAFF",
    guest: "HUÉSPED",
  },
  media: {
    imageAlt: "Imagen enviada",
    locationReceived: "📍 Ubicación recibida",
    openInMaps: "Abrir en Google Maps",
    viewCoordinates: "Ver coordenadas ({lat}, {lng})",
    viewFile: "Ver archivo",
    document: "Documento",
  },
  dropzone: {
    text: "Suelta para adjuntar los archivos",
  },
  failure: {
    notSent: "No se envió",
    notSentDefault: "No enviado",
    reasons: {
      paymentIssue: "problema de pago en la cuenta de WhatsApp",
      cannotReceive: "el número no puede recibir WhatsApp",
      downloadFailed: "WhatsApp no pudo descargar el archivo",
      templateMissingData: "faltan datos en la plantilla",
      requirementsNotMet: "el mensaje no cumple los requisitos de WhatsApp",
    },
  },
  mode: {
    ai: "IA",
    manual: "Manual",
    autoReplyBanner: "El agente está respondiendo automáticamente a este huésped.",
  },
  predefined: {
    header: "Respuestas predefinidas",
    empty: "No se encontraron respuestas predefinidas",
  },
  input: {
    attachFile: "Adjuntar archivo",
    placeholder: "Comience con / para seleccionar una respuesta predefinida.",
    removeFile: "Remover archivo",
  },
  toasts: {
    noBookingLinkedSummary: "Sin reserva vinculada",
    noBookingLinkedDetail: "No hay una reserva asociada a esta conversación",
    errorSummary: "Error",
    userIdError: "No se pudo obtener el ID de usuario",
    manualModeSummary: "Modo Manual Activado",
    aiModeSummary: "Agente IA Activado",
    manualModeDetail: "Tú responderás los mensajes manualmente",
    aiModeDetail: "El bot responderá automáticamente",
    modeChangeError: "No se pudo cambiar el modo del chat",
    reactivateIdError: "No se pudo identificar la conversación para reactivarla.",
    successSummary: "Éxito",
    templateSentOk: "Plantilla enviada correctamente.",
    templateSentError: "No se pudo enviar la plantilla de reactivación.",
    fileTypeSummary: "Tipo de archivo no permitido",
    fileTypeDetail: "{name} no es una imagen ni PDF.",
    fileSizeSummary: "Archivo demasiado grande",
    fileSizeDetail: "{name} supera el límite de 5MB.",
    sendError: "No se pudo enviar el mensaje",
  },
};
